var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapeVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 39.9999C31.0459 39.9999 40.0002 31.0456 40.0002 19.9999C40.0002 8.9542 31.0459 -0.000106812 20.0002 -0.000106812C8.95455 -0.000106812 0.000244141 8.9542 0.000244141 19.9999C0.000244141 31.0456 8.95455 39.9999 20.0002 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40C26.0618 40 31.4933 37.3028 35.161 33.0435H4.83899C8.50672 37.3028 13.9382 40 20 40Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 8.95436 31.0456 -1.52588e-05 20 -1.52588e-05C8.95437 -1.52588e-05 0 8.95436 0 20C0 21.8052 0.240625 23.5538 0.688984 25.2174H39.3111C39.7594 23.5538 40 21.8052 40 20Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58972 27.8261C1.97527 28.732 2.42597 29.6033 2.93558 30.4347H37.0646C37.5741 29.6032 38.0248 28.7319 38.4105 27.8261H1.58972Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2963 21.3044L14.6201 22.3008H15.6678L14.8202 22.9167L15.144 23.9131L14.2963 23.2972L13.4487 23.9131L13.7725 22.9167L12.9249 22.3008H13.9727L14.2963 21.3044Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2963 34.3479L14.6201 35.3444H15.6678L14.8202 35.9601L15.144 36.9565L14.2963 36.3408L13.4487 36.9565L13.7725 35.9601L12.9249 35.3444H13.9727L14.2963 34.3479Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22468 29.9366L8.54843 30.933H9.59616L8.74858 31.5488L9.07233 32.5453L8.22468 31.9295L7.37702 32.5453L7.70093 31.5488L6.85327 30.933H7.90093L8.22468 29.9366Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5437 22.6087L10.8675 23.6052H11.9151L11.0676 24.221L11.3914 25.2174L10.5437 24.6016L9.69607 25.2174L10.02 24.221L9.17224 23.6052H10.22L10.5437 22.6087Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85327 26.7121L7.90077 26.7122L8.2246 25.7156L8.54843 26.7121L9.59616 26.712L8.7485 27.3279L9.07233 28.3244L8.2246 27.7085L7.37702 28.3242L7.70077 27.3278L6.85327 26.7121Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69623 35.4618L10.02 34.4656L9.17224 33.8498H10.22L10.5438 32.8533L10.8676 33.8497H11.9153L11.0676 34.4655L11.3914 35.4621L10.5437 34.8461L9.69623 35.4618Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3655 29.9366L20.0419 30.933H18.9941L19.8416 31.5488L19.5179 32.5453L20.3655 31.9295L21.2132 32.5453L20.8894 31.5488L21.737 30.933H20.6893L20.3655 29.9366Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0465 22.6087L17.7228 23.6052H16.675L17.5225 24.221L17.1988 25.2174L18.0465 24.6016L18.8941 25.2174L18.5703 24.221L19.4179 23.6052H18.3702L18.0465 22.6087Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.737 26.7121L20.6895 26.7122L20.3656 25.7155L20.0419 26.7121L18.9941 26.712L19.8417 27.3279L19.5179 28.3244L20.3656 27.7085L21.2132 28.3241L20.8895 27.3278L21.737 26.7121Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.894 35.4618L18.5703 34.4656L19.418 33.8498H18.3702L18.0464 32.8533L17.7227 33.8497H16.6749L17.5226 34.4655L17.1988 35.4621L18.0465 34.8461L18.894 35.4618Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapeVerde);
export default __webpack_public_path__ + "static/media/cape_verde.4878f0934399c3339f3e01a63070e481.svg";
export { ForwardRef as ReactComponent };